import { Check, Lock } from "lucide-react";
import { TIER_LABEL, tierStyle } from "../lib/tiers";

/**
 * Pastille d'offre aux couleurs du site (Gratuit gris, Essentiel orange, Pro vert, Max violet).
 * - locked : affiche un cadenas (contenu non inclus dans l'offre du lecteur)
 * - label  : texte personnalisé (par défaut le nom de l'offre)
 */
export default function TierBadge({ tier = "free", locked = false, label, className = "", blur = false }) {
  const s = tierStyle(tier);
  return (
    <span
      className={`shrink-0 inline-flex items-center gap-1 px-2 py-1 rounded-full border text-[10px] uppercase tracking-[0.15em] ${s.badge} ${
        blur ? "backdrop-blur" : ""
      } ${className}`}
      data-testid={`tier-badge-${tier}`}
    >
      {locked ? <Lock className="w-3 h-3" /> : tier === "free" ? <Check className="w-3 h-3" /> : null}
      {label || TIER_LABEL[tier] || tier}
    </span>
  );
}
